(function () {
    'use strict';

    angular.module('swif.openbase')
    .directive('swifManagerBookables', ['$q', 'dataService', function ($q, data) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            scope: {

            },
            link: function (scope, element, attr, ngModel) {
                scope.proxy = {sites: [], equipments: []};
                scope.services = [];
                scope.fetchData = function () {
                    var newProxy = {sites: [], equipments: []};
                    if (scope.services.length > 0) {
                        var filter = {fields: ['complete_name', 'name'], limit: 0};
                        data.addFilter(filter, 'resa_service_manager_ids', 'in', scope.services);
                        $q.all(
                            [data.get('site', undefined, filter),
                            data.get('equipment', undefined, filter)]
                        ).then(function (results) {
                            _.forEach(results[0], function (item) {
                                newProxy.sites.push(item);
                            });
                            _.forEach(results[1], function (item) {
                                newProxy.equipments.push(item);
                            });
                            scope.proxy.sites = newProxy.sites;
                            scope.proxy.equipments = newProxy.equipments;
                        });
                    } else {
                        scope.proxy.sites = [];
                        scope.proxy.equipments = [];
                    }
                };

                ngModel.$render = function (){
                    scope.services = ngModel.$viewValue || [];
                    scope.fetchData();
                };

            },
            templateUrl: 'partials/openbase/swifManagerBookables.html'
        };
    }])

    .directive('swifBookableManagers', ['$q', 'dataService', function ($q, data) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            scope: {

            },
            link: function (scope, element, attr, ngModel) {
                scope.proxy = {managers: []};
                scope.services = [];
                scope.fetchData = function () {
                    var newProxy = {managers: []};
                    if (scope.services.length > 0) {
                        var filter = {fields: ['complete_name', 'name'], limit: 0};
                        filter.context = {user_display: 'with_service'};
                        data.addFilter(filter, 'managed_bookable_service_ids', 'in', scope.services);
                        $q.all(
                            [data.get('user', undefined, filter)]
                        ).then(function (results) {
                            _.forEach(results[0], function (item) {
                                newProxy.managers.push(item);
                            });
                            scope.proxy.managers = newProxy.managers;
                        });
                    } else {
                        scope.proxy.managers = [];
                    }
                };

                ngModel.$render = function (){
                    scope.services = ngModel.$viewValue || [];
                    scope.fetchData();
                };

            },
            templateUrl: 'partials/openbase/swifBookableManagers.html'
        };
    }]);

})();
